import cart from '@cell/cell-core/cart';
import Component from '@cell/cell-core/component/component';

import './cart-drawer.scss';

class CartDrawer extends Component {
  constructor() {
    super();

    this.itemCount = this.parsedDataset.itemCount;

    this.handleAddToCart = this.handleAddToCart.bind(this);

    this.handleLineItemQuantityUpdate = this.handleLineItemQuantityUpdate.bind(this);
    this.handleLineItemRemove = this.handleLineItemRemove.bind(this);
  }

  componentDidMount() {
    globalThis.on('product-main.add-to-cart', this.handleAddToCart);
    globalThis.on('upsell-card.add-to-cart', this.handleAddToCart);
    globalThis.on('product-quick-add.add-to-cart', this.handleAddToCart);
    globalThis.on('product-quick-add-drawer.add-to-cart', this.handleAddToCart);
    globalThis.on('bundle-configurator.add-to-cart', this.handleAddToCart);

    this.on('cart-line-item.update-quantity', this.handleLineItemQuantityUpdate);
    this.on('cart-line-item.remove', this.handleLineItemRemove);
  }

  handleAddToCart(event) {
    const { section, quantity } = event.data;

    this.render(section);

    this.itemCount += quantity;

    this.querySelector('c-drawer').open();
  }

  async handleLineItemQuantityUpdate(event) {
    const { key, quantity, previousQuantity } = event.data;

    const item = {
      id: key,
      quantity: quantity,
    };

    const { data, errors, status } = await cart.updateItem(item);

    if (errors.length > 0) {
      // Note: The Cart API only sends a 422 code when standard products are involved. For bundles
      // it just returns a 200 code with the previous cart state. We handle this further down.

      if (status === 422) {
        // The desired quantity is bigger than the available stock.

        // 1. Show max quantity error.

        const updatedLineItemElement = this.querySelector(
          `cart-line-item[data-key="${event.target.key}"]`,
        );

        updatedLineItemElement.showMaxQuantityError();

        // 2. The quantity selector already updated the quantity internally. Reset it to the
        // previous value.

        const updatedLineItemQuantitySelectorElement =
          updatedLineItemElement.querySelector('quantity-selector');

        updatedLineItemQuantitySelectorElement.quantity = previousQuantity;
      }

      return;
    }

    const { item_count: itemCount, sections } = data;

    // 1. Rerender cart content.
    this.render(sections['cart-drawer']);

    // 2. Check if the quantity update action failed due to stock limits being reached.
    if (this.itemCount === itemCount) {
      const updatedLineItemElement = this.querySelector(
        `cart-line-item[data-key="${event.target.key}"]`,
      );

      updatedLineItemElement.showMaxQuantityError();
    }

    // 3. Update current item count.
    this.itemCount = itemCount;
  }

  async handleLineItemRemove(event) {
    const { data, errors } = await cart.removeItem(event.data.key);

    if (errors.length > 0) {
      // TODO: Can this even happen?

      return;
    }

    const { item_count: itemCount, sections } = data;

    // 1. Rerender cart content.
    this.render(sections['cart-drawer']);

    // 2. Update current item count.
    this.itemCount = itemCount;
  }

  render(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // 1. Rerender cart.
    const element = doc.getElementsByTagName(this.tagName)[0];

    this.querySelector('c-drawer').innerHTML = element.querySelector('c-drawer').innerHTML;

    // 2. Notify other components.
    const data = JSON.parse(doc.querySelector('script[type="application/json"]').innerHTML);

    this.emit('render', {
      itemCount: data.itemCount,
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
